"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationCategoryLabels = exports.NotificationCategory = exports.NotificationCatagories = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.NotificationCatagories = ['BILLING', 'DISPATCH', 'AGREEMENTS'];
exports.NotificationCategory = typebox_1.Type.Union(exports.NotificationCatagories.map((method) => typebox_1.Type.Literal(method)));
exports.NotificationCategoryLabels = {
    BILLING: 'Billing',
    DISPATCH: 'Dispatch',
    AGREEMENTS: 'Agreements',
};
//TODO: potentially delete this entirely? dpending on if we want to use the notification category labels in the UI
//# sourceMappingURL=notification-catagories.js.map